import PropTypes from 'prop-types';
import * as React from 'react';

const PlusCircle = React.forwardRef(({ color = 'currentColor', size, strokeWidth = 1.2, ...rest }, ref) => {
  const width = size ?? 20;
  const height = size ?? 20;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <path d="M10 7v6M13 10H7m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0" />
    </svg>
  );
});

PlusCircle.displayName = 'PlusCircle';

PlusCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default PlusCircle;
